'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HighlightContainer, Highlighting } from './styles';
const Highlight = ({ children, color }) => {
    return (_jsxs(HighlightContainer, { children: [_jsx(Highlighting, { "$color": color }), _jsx("span", { style: { position: 'relative' }, children: children })] }));
};
export default Highlight;
